import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { NoSpecialCharactersValidator } from 'src/app/shared/validators/special-characters/special-characters.validator';

import {
  Feature,
  FeatureNames,
  RenameHeatingCircuitCommands,
  RenameHeatingCircuitProperties,
} from '@vi-iot/client';

import { NO_VALUE } from '@pipes';
import { InstallationFeaturesStore } from '@store';

@Component({
  selector: 'edit-heating-circuit-name-modal',
  templateUrl: './edit-heating-circuit-name-modal.component.html',
  styleUrls: ['./edit-heating-circuit-name-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditHeatingCircuitNameModalComponent implements OnInit {
  circuitName: string;
  circuitId: string;
  heatingCircuitNameFeature$: Observable<
    Feature<RenameHeatingCircuitProperties, RenameHeatingCircuitCommands>
  >;
  nameHasSpecialCharacters: boolean;
  circuitNameForm = new FormControl<string>('', [
    Validators.required,
    NoSpecialCharactersValidator(),
  ]);

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<EditHeatingCircuitNameModalComponent>,
    private installationFeaturesStore: InstallationFeaturesStore
  ) {}

  ngOnInit(): void {
    this.circuitNameForm.setValue(this.getHeatingCiruitName(this.data.name));
    this.circuitId = this.data.circuitId;

    this.heatingCircuitNameFeature$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.circuitName(this.circuitId)
    );
  }

  circuitNameChange(name: string, maxLength = 20): void {
    if (name.length > maxLength) {
      this.circuitNameForm.setValue(name.substr(0, maxLength));
    }
  }

  onSaveHeatingCircuitName(): void {
    this.installationFeaturesStore.updateFeature(
      FeatureNames.circuitName(this.circuitId),
      this.circuitNameForm.value,
      'value',
      'name',
      'setName'
    );

    this.onClose();
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onClear(): void {
    this.circuitNameForm.setValue('');
  }

  private getHeatingCiruitName(name: string): string {
    if (!name || name === NO_VALUE) {
      return NO_VALUE;
    }

    if (name.length > 2 && name[1] === '.') {
      return name.substring(3, name.length);
    }

    return name;
  }
}
